import React, { useState, useEffect } from "react";
import translate from "../../reusable/translate";
import Tooltip from "../../materialCommitment/tooltip/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import commitmentSlice from "../../../state/slices/commitmentSlice";
import validatorSlice from "../../../state/slices/validatorSlice";
import { sortCities } from "../../../utils/utils";

const CommitmentInfoDisplay = ({ titleRef }) => {
  const { commitment, language } = useSelector(state => state); // redux
  const [loading, setLoading] = useState(true);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchCities = async () => {
      const cities = await fetch(
        "/o/commitment2050-service/commitmentapi/cities"
      ).then(res => res.json());
      const sortedCities = sortCities(cities, language);
      setCities(sortedCities);
      setLoading(false);
    };
    fetchCities();
  }, []);

  return (
    <div className="flex-column commitment-name">
      <HeaderContainer commitment={commitment} language={language} />

      <CommitmentNameContainer
        titleRef={titleRef}
        commitment={commitment}
        language={language}
      />

      <LocationContainer
        loading={loading}
        cities={cities}
        commitment={commitment}
        language={language}
      />
    </div>
  );
};

export default CommitmentInfoDisplay;

const HeaderContainer = ({ commitment, language }) => {
  return (
    <div className="flex-row items-center margin-top">
      <h3 className="h3">
        {translate({
          textKey: "sit.commitmentCreation.commitmentsInfo.871646",
          languageOverride: language
        })}
      </h3>
      <Tooltip
        textKey={"tooltip.commitmentsInfo.871646"}
        languageOverride={language}
      />
    </div>
  );
};

const CommitmentNameContainer = ({ commitment, language, titleRef }) => {
  const dispatch = useDispatch();
  const { validators } = useSelector(state => state);
  const { changeTitleValidator } = bindActionCreators(
    validatorSlice.actions,
    dispatch
  );
  const { changeCommitmentTitle } = bindActionCreators(
    commitmentSlice.actions,
    dispatch
  );

  return (
    <div className="flex-row items-center margin-top-bot">
      <div className="w300" ref={titleRef}>
        <p className="p">
          {translate({
            textKey: "sit.commitmentCreation.commitmentName.871646",
            languageOverride: language
          })}
        </p>
        <Tooltip
          textKey={"tooltip.commitmentName.871646"}
          languageOverride={language}
        />
      </div>
      <div className="w500">
        <input
          className={`input-text ${
            validators.title ? "" : "input-text-validated"
          }`}
          id={"title-input"}
          value={commitment["title_" + language]}
          placeholder={translate({
            textKey: "sit.commitmentCreation.inputCommitmentName",
            languageOverride: language
          })}
          onChange={e => {
            changeCommitmentTitle({
              title: e.target.value,
              language: language
            });
            changeTitleValidator(true);
          }}
        />
      </div>
    </div>
  );
};

const LocationContainer = ({ commitment, language, loading, cities }) => {
  const dispatch = useDispatch();
  const { validators } = useSelector(state => state);
  const { changeCityValidator } = bindActionCreators(
    validatorSlice.actions,
    dispatch
  );
  const { changeAddress } = bindActionCreators(
    commitmentSlice.actions,
    dispatch
  );

  const handleAddressChange = city => {
    const selectedCity = cities.find(c => c.name_fi_FI === city);
    changeAddress({
      address: selectedCity.name_fi_FI,
      longitude: selectedCity.longitude,
      latitude: selectedCity.latitude
    });
  };

  return (
    <div className="grid35">
      <div className="flex-row">
        <p className="p">
          {translate({
            textKey: "sit.commitmentCreation.selectCity",
            languageOverride: language
          })}
        </p>
        <Tooltip
          textKey={"tooltip.location.871646"}
          languageOverride={language}
        />
      </div>

      {!loading && (
        <select
          className={`select ${validators.city ? "" : "select-validated"}`}
          name="city"
          id="city"
          onChange={e => {
            changeCityValidator(true);
            handleAddressChange(e.target.value); // redux
          }}
          value={commitment.address}
        >
          <option value="">
            {translate({
              textKey: "sit.commitmentCreation.selectCity",
              languageOverride: language
            })}
          </option>
          {cities.map(city => (
            <option key={city.name_fi_FI} value={city.name_fi_FI}>
              {city["name_" + language]}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/circularEconomyCommitment/commitment/CommitmentInfoDisplay.jsx